import { useCanDo } from './useCanDo';
import { useHasMenuKey } from './useHasMenuKey';

/**
 * Whether the current user may load project data.
 * Task screens should not call /project/list unless this is true.
 */
export function useCanAccessProjects() {
  const canViewProjects = useCanDo('projects', 'view');
  const { hasKey: hasProjectMenu, loading } = useHasMenuKey('project');
  const canAccessProjects = !loading && hasProjectMenu && canViewProjects;
  const accessDenied = !loading && (!hasProjectMenu || !canViewProjects);

  return { canAccessProjects, accessDenied, loading };
}
